module.exports = __webpack_public_path__ + "static/media/low_loss_dark.6280e0eb.svg";